import { render, staticRenderFns } from "./UserInfoForm.vue?vue&type=template&id=44ed87ff&scoped=true&"
import script from "./UserInfoForm.vue?vue&type=script&lang=js&"
export * from "./UserInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./UserInfoForm.vue?vue&type=style&index=0&id=44ed87ff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ed87ff",
  null
  
)

export default component.exports